// extracted by mini-css-extract-plugin
module.exports = {"container":"_7b85f8f","header":"_6c8e2ee","body":"_23a8c99","tournamentName":"_fb7435c","tournamentDate":"_528178b","tournamentTime":"_edb2c5a","key":"_3ad7f34","value":"_aaeea00"};